export const Paths = {
  start: '/',
  login: {
    path: '/login',
    urlParams: {
      returnUrl: 'returnUrl',
      token: 't',
      email: 'e',
    },
  },
  policies: '/policies',
  modifyPolicy: '/policies/:policyId',
  documents: '/policies/:policyId/documents',
  profile: '/profile',
};
